import React from "react";
import {TextBox, CheckBox, ComboBox} from "lib/components";
import {useComponentContext } from "lib/components/Context";
import { getDataFromContext } from "lib/util/ModelUtil";
import { PropTypes } from "lib/components/PropTypes";
import { findDesignerComponent } from "./FindDesignerComponent";
import { getLogger } from "lib/util";

const log = getLogger("designer.PropertyEditor");

export function PropertyEditor({content, selectedComponents, propertiesChanged}) {
    let context = useComponentContext();
    let data = getDataFromContext(context);
    let propType = data.propType;

    log.debug("Prop type for " + data.key + " is %o", propType);
    let value;
    if (data.value === undefined)
      value = data.propType.defaultValue;
    else
      value = data.value;

    if (propType.type === PropTypes.bool) {
        return (
            <CheckBox checked={value} onChange={(value, context) => {
                propChanged(value, context, content, selectedComponents)
                propertiesChanged(content);
            }}/>
        );
    }
    else if (propType.values != null) {
      return <ComboBox value={value} items={propType.values} fillRow padding={0}
        variant="undecorated"
        captionVisible={false}
        onChange={(value, context) => {
          value = propType.values[value];
          propChanged(value, context, content, selectedComponents)
          propertiesChanged(content);
      }}/>
    }

    return (
        <TextBox value={value} padding={0} fillRow captionVisible={false} inputProps={{style:{border:"none", background:"unset"}}}
            onChange={(value, context) => {
                if (propType.type === PropTypes.number) {
                    if (value != null && value.length > 0)
                        value = parseInt(value);
                    else
                        value = null;
                }
                propChanged(value, context, content, selectedComponents)
                propertiesChanged(content);
            }}/>
    );
}

function propChanged(value, context, content, selectedComponents) {
    let data = getDataFromContext(context);
    data.value = value;
    for (let i = 0; i < selectedComponents.length; i++) {
        let dataForComponent = findDesignerComponent(content, selectedComponents[i]);
        dataForComponent[data.key] = value;
        log.debug("Prop changed %o", dataForComponent);
    }
}
